import { useEffect } from 'react'

import { GetStaticPropsContext } from 'next'
import { useRouter } from 'next/router'

import { HeadTag, Header } from '@/components'
import { FooterContainer, Page404Container } from '@/containers'
import {
  Footer,
  HeaderMapper,
  getFooterHeader,
} from '@/service/api/footerHeader'
import { usePageContext } from '@/store/pageContext'
import { Constants } from '@/utils/constants'

type Page404Props = {
  footer: Footer
  header: HeaderMapper
}
const Page404: React.FC<Page404Props> = ({ footer, header }) => {
  const router = useRouter()
  const { redirect404 } = usePageContext()

  useEffect(() => {
    if (redirect404) router.replace('/404')
  }, [router, redirect404])
  return (
    <>
      <HeadTag
        title="nata.house"
        description=""
        languageOptions={['en']}
        path="/404"
      />
      {header && <Header headerData={header} />}
      <Page404Container localePtBr={router.locale === 'pt-BR'} />
      {footer && <FooterContainer footerData={footer} />}
    </>
  )
}

export async function getStaticProps(ctx: GetStaticPropsContext) {
  const { footer, header } = await getFooterHeader(String(ctx.locale))
  return {
    props: {
      footer,
      header,
    },
    revalidate: Constants.ONE_MIN,
  }
}
export default Page404
